/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SpecialPlaceVm,
    SpecialPlaceVmFromJSON,
    SpecialPlaceVmFromJSONTyped,
    SpecialPlaceVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface SpecialPlaceVmPaginatedSearchResponse
 */
export interface SpecialPlaceVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<SpecialPlaceVm>}
     * @memberof SpecialPlaceVmPaginatedSearchResponse
     */
    items?: Array<SpecialPlaceVm> | null;
    /**
     * 
     * @type {number}
     * @memberof SpecialPlaceVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SpecialPlaceVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof SpecialPlaceVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof SpecialPlaceVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SpecialPlaceVmPaginatedSearchResponse
     */
    size?: number;
}

export function SpecialPlaceVmPaginatedSearchResponseFromJSON(json: any): SpecialPlaceVmPaginatedSearchResponse {
    return SpecialPlaceVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function SpecialPlaceVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpecialPlaceVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(SpecialPlaceVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function SpecialPlaceVmPaginatedSearchResponseToJSON(value?: SpecialPlaceVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(SpecialPlaceVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


